<template>
  <div style="border: 0px solid black; ; display:block">
    <div class="panel-body">
      <div class="tab-content">
        <div class="tab-pane fade in active" id="tab1warning">
          <!-- SMTP Project -->
          <div>
            <b-card
              no-body
              class="mb-1"
            >
              <b-card-header
                header-tag="header"
                class="p-1"
                role="tab"
              >
                <b-button
                  block
                  v-b-toggle.accordion-2
                  variant="info"
                  >{{ $t("customization_table.smtp_project.title") }}</b-button
                >
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="box-body">
                    <!-- only superadmin -->
                    <div
                      class="col-md-6"
                      v-if="isSuperAdmin()"
                    >
                      <div class="form-group">
                        <label for="title">{{ $t("customization_table.smtp_project.project_name") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="smtp_project.project_name"
                          :placeholder="$t('customization_table.smtp_project.project_name')"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="title">{{ $t("customization_table.smtp_project.sender_alias") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="smtp_project.sender_alias"
                          :placeholder="$t('customization_table.smtp_project.sender_alias')"
                        />
                      </div>
                    </div>
                    <!-- only superadmin -->
                    <div
                      class="col-md-12"
                      v-if="isSuperAdmin()"
                    >
                      <div class="form-group">
                        <label for="title">{{ $t("customization_table.smtp_project.description") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="smtp_project.description"
                          :placeholder="$t('customization_table.smtp_project.description')"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="title">{{ $t("customization_table.smtp_project.page_size") }}</label>
                        <input
                          type="number"
                          class="form-control"
                          v-model="smtp_project.page_size"
                          :placeholder="$t('customization_table.smtp_project.page_size')"
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="title">{{ $t("customization_table.smtp_project.sub_content") }}</label>
                        <textarea
                          rows="8"
                          type="text"
                          class="form-control"
                          v-model="smtp_project.sub_content"
                          :placeholder="$t('customization_table.smtp_project.sub_content')"
                        ></textarea>
                      </div>
                    </div>
                    <div
                      class="box-footer"
                      style="padding-bottom: 0"
                    >
                      <button
                        type="button"
                        class="btn btn-labeled btn-success pull-right"
                        style="margin-right: 5px;"
                        @click="onSave_SMTP_Project"
                      >
                        <span class="btn-label">
                          <i class="glyphicon glyphicon-ok"></i>
                        </span>
                        {{ $t("common.save") }}
                      </button>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
            <!-- <div v-else>
              <p style="color: red; text-align: center">
                {{ $t("customization_table.error_connect_server") }}
              </p>
            </div> -->
          </div>
          <!-- SMTP Email -->
          <b-card
            no-body
            class="mb-1"
          >
            <b-card-header
              header-tag="header"
              class="p-1"
              role="tab"
            >
              <b-button
                block
                v-b-toggle.accordion-3
                variant="info"
                >{{ $t("customization_table.smtp_email.title") }}
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="box-body">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">{{ $t( "customization_table.smtp_email.smtp_domain") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="smtp_email.smtp_domain"
                        :placeholder="$t('customization_table.smtp_email.smtp_domain')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">{{ $t("customization_table.smtp_email.smtp_port") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="smtp_email.smtp_port"
                        :placeholder="$t('customization_table.smtp_email.smtp_port')"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">{{ $t("customization_table.smtp_email.smtp_sender") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="smtp_email.smtp_sender"
                        :placeholder="$t('customization_table.smtp_email.smtp_sender')"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">{{ $t("customization_table.smtp_email.smtp_password") }}</label>
                      <b-button
                        class="form-control"
                        variant="primary"
                        @click="onShowModalChangePasswordEmailConfig"
                      >{{$t('user.password_modal[0].title')}}</b-button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <input
                        type="checkbox"
                        v-model="smtp_email.smtp_use_tls"
                        :placeholder="$t('customization_table.smtp_project.page_size')"
                      />
                      <label for="title">{{ $t("customization_table.smtp_email.smtp_use_tls") }}</label>
                    </div>
                  </div>
                </div>
                <div class="box-footer" style="padding-bottom: 0">
                  <button
                    type="button"
                    class="btn btn-labeled btn-warning"
                    style="margin-right: 5px;"
                    @click="sendTestEmail"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-send"></i>
                    </span>
                    {{ $t("common.sendTest") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    style="margin-right: 5px;"
                    @click="save_Config_SMTP_Email_Server"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-ok"></i>
                    </span>
                    {{ $t("common.save") }}
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!--  -->
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading :active.sync="is_loading" :can-cancel="false" color="#1E90FF">
    </loading>
    <!--  -->
    <div class="modal modal-default" id="modal-change-password-email-smtp">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t('user.password_modal[0].title') }}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                for="title"
              >{{ $t('customization_table.smtp_email.smtp_password') }}</label>
              <input
                class="form-control"
                v-model="smtp_email.smtp_password"
                type="password"
                id="smtp_password"
                :placeholder="$t('customization_table.smtp_email.smtp_password')"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              >{{ $t('confirm_email.btnClose') }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdatePasswordEmailConfig"
              >{{ $t('confirm_email.btnConfirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <sendTestEmailModal ref="sendEmailTesting" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils'
import SendTestEmailModal from "./SendTestEmailModal.vue"

export default {
  name: "ConfigSMTPProject",
  props: {
    smtpProjectId: {
      type: Number,
      default: () => {
        return null;
      }
    },
  },
  data() {
    return {
      smtp_project: {
        project_name: "",
        sender_alias: "",
        page_size: null,
        sub_content: "",
        description: ""
      },
      smtp_email: {
        smtp_domain: null,
        smtp_sender: null,
        smtp_port: null,
        smtp_password: null,
        smtp_use_tls: true
      },
      is_loading: false
    };
  },
  watch: {
    smtpProjectId: function() {
      this.loadSMTPConfig()
    },
    GET_SMTP_PROJECT_DATA: function() {
      this.smtp_project.project_name = this.GET_SMTP_PROJECT_DATA.project_name;
      this.smtp_project.sender_alias = this.GET_SMTP_PROJECT_DATA.sender_alias;
      this.smtp_project.sub_content = this.GET_SMTP_PROJECT_DATA.tail_content;
      this.smtp_project.page_size = this.GET_SMTP_PROJECT_DATA.pagination;
      this.smtp_project.description = this.GET_SMTP_PROJECT_DATA.description;
    },
    GET_CONFIG_SMTP_EMAIL_SERVER_DATA: function() {
      this.smtp_email.smtp_domain = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.smtp_domain;
      this.smtp_email.smtp_sender = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.smtp_sender;
      this.smtp_email.smtp_port = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.smtp_port;
      this.smtp_email.smtp_use_tls = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.smtp_use_tls;
      this.smtp_email.smtp_password = null;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_SMTP_PROJECT_DATA",
      "GET_CONFIG_SMTP_EMAIL_SERVER_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_SMTP_PROJECT",
      "PUSH_SMTP_PROJECT",
      "GET_CONFIG_SMTP_EMAIL_SERVER",
      "PUSH_CONFIG_SMTP_EMAIL_SERVER",
      "PUSH_SMTP_PASWORD"
    ]),
    isSuperAdmin: function() {
        return utils.isSuperAdmin(this.GET_ACCOUNT_DATA);
    },
    get_data_null: function(data) {
      if (data === null || data === "") {
        return null;
      } else return data;
    },
    loadSMTPConfig: function() {
      this.smtp_project.project_name = null;
      this.smtp_project.sender_alias = null;
      this.smtp_project.sub_content = null;
      this.smtp_project.page_size = null;
      this.smtp_project.description = null;
      this.smtp_email.smtp_domain = null;
      this.smtp_email.smtp_sender = null;
      this.smtp_email.smtp_port = null;
      this.smtp_email.smtp_use_tls = null;
      this.smtp_email.smtp_password = null;

      if (this.smtpProjectId != null) {
        let filter = {
          params: {
            smtpProjectId: this.smtpProjectId
          }
        };
        this.GET_SMTP_PROJECT(filter)
        this.GET_CONFIG_SMTP_EMAIL_SERVER(filter)
      }
    },
    onSave_SMTP_Project: function() {
      if (this.smtp_project.page_size <= 0) {
        this.ON_SHOW_TOAST({
          message: "Page size not validate",
          styleType: "danger"
        });
      } else {
        let data = {
          smtpProjectId: this.smtpProjectId,
          projectName: utils.getCleanStringValue(this.smtp_project.project_name),
          senderAlias: utils.getCleanStringValue(this.smtp_project.sender_alias),
          pageSize: this.smtp_project.page_size,
          tailContent: utils.getCleanStringValue(this.smtp_project.sub_content),
          description: utils.getCleanStringValue(this.smtp_project.description)
        };
        this.PUSH_SMTP_PROJECT(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    // SMTP Email Server
    getSMTPEmailServer: function() {
      this.is_loading = true;
      let filter = {
        params: {
          smtpProjectId: this.smtpProjectId,
        }
      };
      this.GET_CONFIG_SMTP_EMAIL_SERVER(filter)
        .then(
          function(res) {
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.is_loading = false;
          }.bind(this)
        );
    },
    validateData_SMTP_Email: function() {
      let validatedResult = "OK";
      for (let key in this.smtp_email) {
        if (key === 'smtp_password') {
          // 
        } else if (this.smtp_email[key] === null || this.smtp_email[key] === "") {
          validatedResult =
            "Vui Lòng Nhập: " +
            this.$t("customization_table.smtp_email." + key);
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    save_Config_SMTP_Email_Server: function() {
      let result = this.validateData_SMTP_Email();
      if (result == "OK") {
        this.is_loading = true;
        let data = {
          smtpProjectId: this.smtpProjectId,
          smtpDomain: utils.getCleanStringValue(this.smtp_email.smtp_domain),
          smtpSender: utils.getCleanStringValue(this.smtp_email.smtp_sender),
          smtpUseTls: utils.getCleanStringValue(this.smtp_email.smtp_use_tls),
          smtpPort: utils.getCleanStringValue(this.smtp_email.smtp_port)
        };
        this.PUSH_CONFIG_SMTP_EMAIL_SERVER(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.getSMTPEmailServer();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    sendTestEmail: function () {
      this.$refs.sendEmailTesting.onShowModal(this.smtpProjectId)
    },
    onShowModalChangePasswordEmailConfig: function () {
      $("#modal-change-password-email-smtp").modal("show");
      this.smtp_email.smtp_password = null
    },
    onUpdatePasswordEmailConfig: function () {
      if(utils.isEmptyString(this.smtp_email.smtp_password)) {
        this.ON_SHOW_TOAST({
          message: this.$t('customization_table.smtp_email.smtp_password'),
          styleType: "danger"
        });
      } else {
        this.is_loading=true;
        let data = {
          smtpProjectId: this.smtpProjectId,
          smtpPassword: utils.getCleanStringValue(this.smtp_email.smtp_password),
        };
        this.PUSH_SMTP_PASWORD(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              $("#modal-change-password-email-smtp").modal("hide");
              this.getSMTPEmailServer()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onClickGetDataTab: function(index) {
      switch (index) {
        case 1:
          this.$refs.ConfigSidebarList.getDataConfigSideBarList();
          break;
      }
    },
    onSelectTab: function(value) {
      switch (value) {
        case 1:
          this.getSMTPEmailServer();
          break;

        case 2:
          this.$refs.customizationProjectSMTP.onGetData()
          break;

        default:
          break;
      }
    }
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    SendTestEmailModal
  }
};
</script>

<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL WARNING ***/
.with-nav-tabs.panel-warning .nav-tabs > li > a,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning .nav-tabs > .open > a,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
  background-color: #faebcc;
  border-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.active > a,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:focus {
  color: #8a6d3b;
  background-color: #fff;
  border-color: #faebcc;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #faebcc;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  color: #fff;
  background-color: #8a6d3b;
}
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ConfigSMTPProject.vue